import { render, staticRenderFns } from "./AddCardCollectionBtn.vue?vue&type=template&id=ad48eefa&"
import script from "./AddCardCollectionBtn.vue?vue&type=script&lang=js&"
export * from "./AddCardCollectionBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad48eefa')) {
      api.createRecord('ad48eefa', component.options)
    } else {
      api.reload('ad48eefa', component.options)
    }
    module.hot.accept("./AddCardCollectionBtn.vue?vue&type=template&id=ad48eefa&", function () {
      api.rerender('ad48eefa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/components/PostForm/AddCardCollectionBtn.vue"
export default component.exports